var React = require('react');

function LinkedinInlineInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;}.cls-2{fill:#909292;}")),React.createElement("rect",{"className":"cls-2","x":"2.5","y":"2.5","width":"300","height":"300","rx":"15.45","ry":"15.45","key":1}),React.createElement("path",{"className":"cls-1","d":"M62.72,121.37h38.53v123.76h-38.53v-123.76ZM81.99,59.87c12.32,0,22.3,10,22.3,22.29s-9.98,22.32-22.3,22.32-22.33-10.01-22.33-22.32,9.98-22.29,22.33-22.29","key":2}),React.createElement("path",{"className":"cls-1","d":"M125.38,121.37h36.9v16.93h.5c5.15-9.74,17.69-19.99,36.43-19.99,38.95,0,46.13,25.61,46.13,58.94v67.88h-38.44v-60.17c0-14.36-.28-32.82-19.99-32.82s-23.08,15.63-23.08,31.77v61.22h-38.45v-123.76Z","key":3})]);
}

LinkedinInlineInline.defaultProps = {"width":"26","height":"23","id":"Layer_1","viewBox":"0 0 305 305"};

module.exports = LinkedinInlineInline;

LinkedinInlineInline.default = LinkedinInlineInline;
